import { convertToQueryParams } from "../../utils/converter";

export const getPatients =
  (data: any) => async (dispatch: Function, _getState: Function, api: any) => {
    try {
      const queryParams = convertToQueryParams(data).replace(/where\./g, "");
      return await api.get(`patient?${queryParams}`);
    } catch (err) {
      console.error(err);
      return null;
    }
  };

export const getCommlogHistory =
  ({ patNum, practiceDBName }: { patNum: string; practiceDBName: string }) =>
  async (dispatch: Function, _getState: Function, api: any) => {
    try {
      return await api.get(
        `patient/commlog-history?patNum=${patNum}&practiceDBName=${practiceDBName}`,
      );
    } catch (err) {
      console.error(err);
      return [];
    }
  };

export const getReviewSummary =
  () => async (dispatch: Function, _getState: Function, api: any) => {
    try {
      return await api.get(`patient/review-summary`);
    } catch (err) {
      console.error(err);
      return [];
    }
  };

// Pass ids, or practiceId + importDate (YYYY-MM-DD) for a whole batch.
export const reviewPatients =
  (payload: {
    action: "approve" | "reject" | "rereview";
    ids?: number[];
    practiceId?: number;
    importDate?: string;
    sync?: boolean;
  }) =>
  async (dispatch: Function, _getState: Function, api: any) => {
    try {
      return await api.post(`patient/review`, payload);
    } catch (err) {
      console.error(err);
      return null;
    }
  };

export const updatePatientStatus =
  (id: number, status: string) =>
  async (dispatch: Function, _getState: Function, api: any) => {
    try {
      return await api.put(`patient/${id}/status/${status}`);
    } catch (err) {
      console.error(err);
      return null;
    }
  };
